import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  addCondition: {
    id: 'core.category.grid.config.rules.condition.add',
    defaultMessage: 'Add condition',
  },
  deleteCondition: {
    id: 'core.category.grid.config.rules.condition.delete',
    defaultMessage: 'Remove condition',
  },
  condition: {
    id: 'core.category.grid.config.rules.condition',
    defaultMessage: 'Condition',
  },
  style: {
    id: 'core.category.grid.config.rules.style',
    defaultMessage: 'Style',
  },
  font: {
    id: 'core.category.grid.config.rules.font',
    defaultMessage: 'Font',
  },
  textColor: {
    id: 'core.category.grid.config.rules.style.text',
    defaultMessage: 'Text color',
  },
  textColorErr: {
    id: 'core.category.grid.config.rules.style.text.err',
    defaultMessage: `text won't be visible as bg has same color`,
  },
  backgroundColor: {
    id: 'core.category.grid.config.rules.style.background',
    defaultMessage: 'Background color',
  },
  textBold: {
    id: 'core.category.grid.config.rules.style.text.bold',
    defaultMessage: 'Bold',
  },
  textItalic: {
    id: 'core.category.grid.config.rules.style.text.italic',
    defaultMessage: 'Italic',
  },
  textUnderline: {
    id: 'core.category.grid.config.rules.style.text.underline',
    defaultMessage: 'Underline',
  },
  textLineThrough: {
    id: 'core.category.grid.config.rules.style.text.lineThrough',
    defaultMessage: 'Line-through',
  },
  example: {
    id: 'core.category.grid.config.rules.style.text.example',
    defaultMessage: 'Cell example ({parity})',
  },
  caseSensitive: {
    id: 'core.category.grid.config.rules.caseSensitive',
    defaultMessage: 'Case sensitive',
  },
  startDate: {
    id: 'core.category.grid.config.rules.date.start',
    defaultMessage: 'From',
  },
  endDate: {
    id: 'core.category.grid.config.rules.date.end',
    defaultMessage: 'To',
  },
  greater: {
    id: 'core.category.grid.config.rules.number.greater',
    defaultMessage: 'Greater than',
  },
  less: {
    id: 'core.category.grid.config.rules.number.less',
    defaultMessage: 'Less than',
  },
  applyToRow: {
    id: 'core.category.grid.config.rules.forRow',
    defaultMessage: 'Apply to row',
  },
  emptyValue: {
    id: 'core.category.grid.config.rules.emptyValue',
    defaultMessage: 'Empty value',
  },
  notEmptyValue: {
    id: 'core.category.grid.config.rules.notEmptyValue',
    defaultMessage: 'Not empty value',
  },
});
